import React from "react"
import Skeleton from '../UI/Skeleton'

class StudyCardSkeleton extends React.Component {
    render() {
        return (
            <div className="col-12">
                <div className="col-12 card course-card">
                    <div className='card-img-wrapper'>
                        <Skeleton className="card-img" height={250} />
                    </div>
                    <div className="card-body-wrapper">
                        <div className="card-body">
                            <Skeleton className="card-title lg-font-size" />
                            <div className="card-desc">
                                <Skeleton className="md-font-size" count={5} />
                            </div>
                            <div className="card-tags xs-font-size w-100">
                                <Skeleton className="card-tag xs-font-size" width={80} />
                                <Skeleton className="card-tag xs-font-size" width={80} />
                                <Skeleton className="card-tag xs-font-size" width={80} />
                                <Skeleton className="card-tag xs-font-size" width={80} />
                            </div>
                        </div>
                        <div className="card-whitespace"></div>
                        <div className="card-bottom">
                            <div className="progress-text">
                                <Skeleton className="text xs-font-size" width={100} />
                                <Skeleton className="number md-font-size" width={50} />
                            </div>
                            <Skeleton className="btn profile-avatar-btn grey p-10-20px" width={165} />
                        </div>
                        <Skeleton className="custom-progress" />
                    </div>
                </div>
                <div className="col-12 card course-card">
                    <div className='card-img-wrapper'>
                        <Skeleton className="card-img" height={250} />
                    </div>
                    <div className="card-body-wrapper">
                        <div className="card-body">
                            <Skeleton className="card-title lg-font-size" />
                            <div className="card-desc">
                                <Skeleton className="md-font-size" count={5} />
                            </div>
                            <div className="card-tags xs-font-size w-100">
                                <Skeleton className="card-tag xs-font-size" width={80} />
                                <Skeleton className="card-tag xs-font-size" width={80} />
                                <Skeleton className="card-tag xs-font-size" width={80} />
                                <Skeleton className="card-tag xs-font-size" width={80} />
                            </div>
                        </div>
                        <div className="card-whitespace"></div>
                        <div className="card-bottom">
                            <div className="progress-text">
                                <Skeleton className="text xs-font-size" width={100} />
                                <Skeleton className="number md-font-size" width={50} />
                            </div>
                            <Skeleton className="btn profile-avatar-btn grey p-10-20px" width={165} />
                        </div>
                        <Skeleton className="custom-progress" />
                    </div>
                </div>
            </div>
        )
    }
}

export default StudyCardSkeleton


// WEBPACK FOOTER //
// ./src/components/Study/StudyCardSkeleton.jsx